export const hasGetUserMedia = (): boolean =>
	!!navigator.mediaDevices?.getUserMedia;

export const polyfillGetUserMedia = () => {
	// Older browsers might not implement mediaDevices at all, so we set an empty object first
	if (navigator.mediaDevices === undefined) {
		(navigator as any).mediaDevices = {};
	}

	// Some browsers partially implement mediaDevices. We can't just assign an object
	// with getUserMedia as it would overwrite existing properties.
	// Here, we will just add the getUserMedia property if it's missing.
	if (navigator.mediaDevices.getUserMedia === undefined) {
		navigator.mediaDevices.getUserMedia = (constraints) => {
			// First get ahold of the legacy getUserMedia, if present
			const getUserMedia =
				navigator.getUserMedia ||
				navigator.webkitGetUserMedia ||
				navigator.mozGetUserMedia ||
				navigator.msGetUserMedia;

			// Some browsers just don't implement it - return a rejected promise with an error
			// to keep a consistent interface
			if (!getUserMedia) {
				return Promise.reject(
					new Error("getUserMedia is not implemented in this browser"),
				);
			}

			// Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
			return new Promise((resolve, reject) => {
				getUserMedia.call(navigator, constraints, resolve, reject);
			});
		};
	}
};

export function stopMediaStream(stream: MediaStream | null) {
	if (stream) {
		if (stream.getVideoTracks && stream.getAudioTracks) {
			const videoTracks = stream.getVideoTracks();
			for (const track of videoTracks) {
				stream.removeTrack(track);
				track.stop();
			}
			const audioTracks = stream.getAudioTracks();
			for (const track of audioTracks) {
				stream.removeTrack(track);
				track.stop();
			}
		} else {
			(stream as unknown as MediaStreamTrack).stop();
		}
	}
}
